import { render, staticRenderFns } from "./TabUpVacation.vue?vue&type=template&id=e00efbca"
import script from "./TabUpVacation.vue?vue&type=script&lang=js"
export * from "./TabUpVacation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports